import { render, staticRenderFns } from "./LabelValue.vue?vue&type=template&id=cd9e7fa0&scoped=true"
import script from "./LabelValue.vue?vue&type=script&lang=ts"
export * from "./LabelValue.vue?vue&type=script&lang=ts"
import style0 from "./LabelValue.vue?vue&type=style&index=0&id=cd9e7fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9e7fa0",
  null
  
)

export default component.exports